const messages = {
  title: "Moj lični izvještaj računa",
  desc: "Ovde možete pregledati vaš lični Bridgestone Plus izvještaj računa sa vašim zaradenim i iskorišćenim bonus poenima. Molimo imajte na umu da može proći do 6 nedelja da se poeni uračunaju za vaše narudžbe guma, u zavisnosti od izvora.",
  score: "Stanje poena",
  regularPoints: "Redovni poeni",
  boosterPoints: "Bonus poeni",
  date: "Datum",
  supplySourceReason: "Izvor/Razlog kupovine",
  article: "Artikal",
  brand: "Brend",
  product: "Proizvod",
  type: "Tip",
  inch: "Inč",
  season: "Sezona",
  amount: "Količina",
  standardPoints: "Poeni",
  boosterProduct: "Bonus proizvod",
  boosterSeason: "Bonus sezona",
  otherActions: "Druge akcije ili razlozi",
  totalPoints: "Ukupno poena",
  income: "Prihod",
  spending: "Rashodi",
  lastMonth: "Završno stanje",
  loadMore: "Učitajte još 20 transakcija",
  typeFilter: "Filtrirajte po izvoru",
  dateFilter: "Filtrirajte po periodu",
  customer_number: "Broj kupca",
  currentPoints: "Trenutni poeni",
  calculationDate: "Datum izračuna",
  positivePoints: "Pozitivni poeni",
  negativePoints: "Već potrošeno",
  tyresAmount: "Broj guma godišnje",
  pointsTotal: "Ukupno poena",
  currentPointState: "Trenutno stanje poena",
  currentKickbackState: "Trenutni kešbek",
  pointsFromCurrentYear: "Dodavanje: poeni iz tekuće godine ({year})",
  pointsAtRiskOfExpiry: "Poeni za potrošnju do 31.03.{year}",
  points: "Poeni",
  noDataFound: "Podaci nisu pronađeni",
  seasons: {
    summer: "Leto",
    winter: "Zima",
    all: "Sve sezone",
  },
};
export default {
  messages,
};
